
import React from "react";

export const PitchEsp = () => {
  return (
    <div className="pitch-section">
      <h1>MOKA PITCH EN ESPAÑOL</h1>
      <p>
        MokaToken, una solución
        revolucionaria para cafeterías que redefine la experiencia de pago.
        Imaginen ofrecer a sus clientes la facilidad de pagar con MokaTokens,
        donde la conveniencia se encuentra con la innovación. MokaToken ofrece
        dos vías sin complicaciones para abrazar esta evolución.
      </p>
      <p>
        Primero, a través de nuestra integración con web3, los clientes adquieren
        MokaTokens sin esfuerzo utilizando sus billeteras de criptomonedas. Esto
        posiciona su cafetería como un destino moderno y atrae a los entusiastas
        de las criptomonedas. Para aquellos que son nuevos en el mundo de las
        criptomonedas, nuestra aplicación web amigable les permite iniciar
        sesión con su correo electrónico. Se genera una billetera dedicada para
        ellos y pueden financiarla a través de depósitos bancarios
        tradicionales. Estos fondos se convierten luego en MokaTokens para
        realizar compras, fusionando las finanzas tradicionales con el mundo de
        las criptomonedas.
      </p>
      <p>
        MokaToken no se trata solo de pagos, sino de mejorar
        las experiencias. Los clientes pueden comprar tokens para sí mismos o
        como encantadores regalos. Los propietarios de cafeterías obtienen
        información en tiempo real sobre los patrones de uso, mejorando las
        ofertas en función de las preferencias de los clientes. Al ofrecer
        MokaToken, su cafetería se convierte en un referente, abrazando la
        innovación y la vanguardia. En un mundo donde los clientes valoran ambas
        cosas, MokaToken los distingue. Únanse a nosotros para dar forma al
        futuro de los pagos. Inviertan en MokaToken hoy y transformemos su
        cafetería en un centro de transacciones impecables.
      </p>
      <p>
        Gracias
      </p>
    </div>
  );
};
